// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'kt-confirm-ckeditor-entity-dialog',
	templateUrl: './confirm-ckeditor-entity-dialog.component.html',
  styleUrls: ['../modal.scss']
})
export class ConfirmCkeditorEntityDialogComponent implements OnInit {
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
	widget_Buttons_map = ['dial', 'email'];
	constructor(
		public dialogRef: MatDialogRef<ConfirmCkeditorEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
			this.dialogRef.close(this.data.data);
	}

	public onChange(data) {
      this.data.data = data;
  }
}
